import actionTypes from '../actions/actionTypes'
import onboardingGuideCardTypes from 'helpers/enums/onboardingGuideCardTypes'
import onboardingGuideCardStatusTypes from 'helpers/enums/onboardingGuideCardStatusTypes'

const defaultState = {
	cards: [],
}

function setOnboardingGuideData(state, action) {
	return {
		...state,
		cards: action.payload.cards,
	}
}

function dismissOnboardingGuide(state) {
	return {
		...state,
		cards: defaultState.cards,
	}
}

function completeLaunchTourCard(state) {
	const cards = state.cards.map(card => {
		if (card.type === onboardingGuideCardTypes.LAUNCH_TOUR
			&& card.status === onboardingGuideCardStatusTypes.PENDING) {
			return {
				...card,
				status: onboardingGuideCardStatusTypes.COMPLETED,
			}
		}
		return card
	})

	return {
		...state,
		cards,
	}
}

const onboardingGuideReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.ONBOARDING_GUIDE_DATA_FETCHED:
		case actionTypes.ONBOARDING_GUIDE_ENABLED:
			return setOnboardingGuideData(state, action)
		case actionTypes.ONBOARDING_GUIDE_DISMISS_CONFIRMED:
			return dismissOnboardingGuide(state)
		case actionTypes.ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SUCCESS:
			return completeLaunchTourCard(state)
		default:
			return state
	}
}

export default onboardingGuideReducer

export {
	onboardingGuideReducer,
}
